import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared/core2Config';
import { DgMktSalesTrackingReportContainerModel } from '../../../../../../models';
import { ApiVisa, Pagination } from '../../shared';

@Injectable({
  providedIn: 'root',
})
export class DgMktSalesTrackingReportService extends BaseApiTemplateService<DgMktSalesTrackingReportContainerModel> {
  readonly url =
    Core2Config.TENANT_DOMAIN_URL_PREFIX +
    Core2Config.DGMKT_MODULE_PREFIX +
    'sales-tracking-reports';

  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'sales-tracking-reports';

    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.DGMKT_MODULE_PREFIX +
      'sales-tracking-reports';

    this.httpClient = http;
  }

  public generateSalesTrackingReportByCampaignGuid(
    pagination: Pagination,
    visa: ApiVisa
  ) {
    let { apiUrl } = this;

    if (this.endpoint_path && visa.api_domain_url) {
      apiUrl = visa.api_domain_url + this.endpoint_path;
    }

    return this.httpClient.get(
      apiUrl + '/generate?' + pagination.getQueryKeyValues(),
      this.getHttpHeader(visa)
    );
  }

  async exportSalesTrackingReportCsvAsBlob(
    pagination: Pagination,
    apiVisa: ApiVisa
  ) {
    let { apiUrl } = this;

    if (this.endpoint_path && apiVisa.api_domain_url) {
      apiUrl = apiVisa.api_domain_url + this.endpoint_path;
    }

    const CSV_URL =
      apiUrl + '/export/csv/backoffice-ep?' + pagination.getQueryKeyValues();

    const headers = new HttpHeaders({
      authorization: apiVisa.jwt_secret,
      tenantCode: apiVisa.tenantCode,
    });

    const fileBlob = await this.httpClient
      .get(CSV_URL, { headers, responseType: 'blob' })
      .toPromise();

    return fileBlob;
  }
}
